const initialProps = {
  ticketFour: {
    id: "0",
    totalTicket: 0,
    cliente: "",
  },
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKET_FOUR":
      return {
        ...state,
        ticketFour: action.payload,
      };
    case "UPDATE_TICKET_FOUR":
      return {
        ...state,
        ticketFour: action.payload,
      };
    default:
      return state;
  }
}
